import { Atom, atom } from '@cloudio-saas/statex';
import { observable } from '@legendapp/state';

export const LIST_ID = '$$_LIST_$$';

export const filtersChangedByIdAtom = atom<{ id: string; version: number }>({
  path: ['transient', ':appUid', ':pageId', ':itemId', 'filtersChangedById'],
  defaultValue: { id: '', version: 0 },
});

export const paginationValueAtom: Atom<number> = atom<number>({
  path: ['transient', ':appUid', ':pageId', ':itemId', 'paginationValue'],
  defaultValue: 1,
});
export const lastSelectedRowAtom: Atom<number> = atom<number>({
  path: ['transient', ':appUid', ':pageId', ':itemId', 'lastSelectedRow'],
  defaultValue: 0,
});

export const hoverRowState = observable<{
  hoverRow: {
    pageId: string;
    appUid: string;
    itemId: string;
    rowIndex: number;
  };
}>({ hoverRow: { pageId: '', appUid: '', itemId: '', rowIndex: -1 } });
